import React, { useEffect, useRef, useState, useCallback } from "react";
import "./AiConversationModel.scss";
import { Flex, Modal } from "antd";
import { ReactComponent as CollectEaze } from "../../../assets/Icons/CollectEaze.svg";
import { ReactComponent as Customer } from "../../../assets/Icons/Customer.svg";
import GreenSmile from "../../../assets/Icons/GreenSmile.svg";
import GaugeChart from "../../../Reuseable/GaugeChart/GaugeChart";
import AudioPlayer from "../../../Reuseable/AudioPlayer/AudioPlayer";

const AiConversationModel = ({ open, onClose }) => {
  const scrollRef = useRef(null);
  const [scrollClass, setScrollClass] = useState("");

  const conversation = [
    {
      sender: "AI Bot",
      time: "01:00pm.",
      message:
        "Hello. This is an automated call from CollectEaze regarding your loan settlement. For verification, please confirm your registered mobile number.",
      icon: <CollectEaze />,
    },
    {
      sender: "Customer",
      time: "01:32pm.",
      message: "Yes, it’s 9876543210.",
      icon: <Customer />,
    },
    {
      sender: "AI Bot",
      time: "01:32pm.",
      message: "Thank you. Please confirm your date of birth for verification.",
      icon: <CollectEaze />,
    },
    {
      sender: "Customer",
      time: "01:33pm.",
      message: "silence",
      icon: <Customer />,
    },
    {
      sender: "AI Bot",
      time: "01:34pm.",
      message:
        "I'm sorry, I didn't catch that. Please say or enter your date of birth.",
      icon: <CollectEaze />,
    },
    {
      sender: "Customer",
      time: "01:33pm.",
      message: "silence",
      icon: <Customer />,
    },
    {
      sender: "AI Bot",
      time: "01:34pm.",
      message: "Thank you. We'll arrange a callback shortly.",
      icon: <CollectEaze />,
    },
  ];

  const updateBlur = useCallback(() => {
    const container = scrollRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollHeight <= clientHeight + 1) {
      setScrollClass(""); // No scroll
    } else if (scrollTop <= 0) {
      setScrollClass("scroll-bottom"); // Only bottom blur
    } else if (scrollTop + clientHeight >= scrollHeight - 1) {
      setScrollClass("scroll-top"); // Only top blur
    } else {
      setScrollClass("scroll-middle"); // Both top and bottom
    }
  }, []);

  useEffect(() => {
    const container = scrollRef.current;
    if (!open || !container) return;

    updateBlur(); // Initial call
    container.addEventListener("scroll", updateBlur);

    return () => {
      container.removeEventListener("scroll", updateBlur);
    };
  }, [open, updateBlur]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={
        <Flex className="ai-modal-footer">
          <Flex className="footer">
            <p>Sentiment</p>
            <button>
              <img src={GreenSmile} alt="GreenSmile" />
              Positive
            </button>
          </Flex>
          <Flex className="footer">
            <p>
              Predicted <br /> Disposition
            </p>
            <Flex className="data-and-graph">
              <Flex className="data">
                <p className="data-head">PTP</p>
                <h1>88%</h1>
              </Flex>
              <GaugeChart percent={0.88} />
            </Flex>
          </Flex>
        </Flex>
      }
      title={
        <div className="modal-header">
          AI Call Transcript <span>Apr 23, 2025 — 6:17 PM</span>
        </div>
      }
      width={581}
      className={`AiConversationModel ${scrollClass}`}
    >
      <div className="blurTop" />
      <div className="blurBottom" />

      <div className="modalScrollWrapper" ref={scrollRef}>
        <div className="conversation-timeline">
          {conversation.map((item, index) => (
            <div className="timeline-item" key={index}>
              <div className="timeline-icon">
                {typeof item.icon === "string" ? (
                  <div className="circle-icon">{item.icon}</div>
                ) : (
                  item.icon
                )}
              </div>
              <div className="timeline-content">
                <div className="sender-time">
                  <span className="sender">{item.sender}</span>
                  <span className="time">{item.time}</span>
                </div>
                <div className="message">{item.message}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="manual-player">
        <AudioPlayer
          src="/audios/sample.mp3"
          rewindSeconds={5}
          forwardSeconds={5}
          width="100%"
        />
      </div>
    </Modal>
  );
};

export default AiConversationModel;
